import { store } from '@betacrew/jars-flux';
import { all, call, put,select, takeLatest } from 'redux-saga/effects';
import PayerDataService from '../../../../services/PayerDataService'
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice'; 
import { COMMON_EXPORTING_STATES, COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import { componentKey, setLoadingState, setMemberData, setExportFile, setTotalMembers, setSelectedMember, setUploadedFile, setShowImportPopup, setMemberRoles, setDisabledFields, setShowUserInfoPopup, setShouldLoadMemberList, setIsAllowMemberToCreate } from './ManageUserSlice';
import RightsManagementDataService from '../../../../services/RightsManagementDataService';
import { USER_LOADING_STATES } from '../constant';

export const { assignGroupID, assignPayersToMemberUser, createMemberUser, updateMemberUser, getRolesPermissions, getMemberRoles, getMembersList, exportToExcelMemberUserPayers, exportMemberUser, changeUserStatus, getTemplate, changeAssignPayers, deleteMember, uploadSheet, reRequest, checkCreateMemberAllowed} = {
    getMembersList: (payload) => {
        return {
            type: "USERS/GET_MEMBERS_LIST",
            payload: payload
        }
    },
    exportToExcelMemberUserPayers: (payload) => {
        return {
            type: "USERS/EXPORT_EXCEL_MEMBER_USER_PAYERS",
            payload: payload
        }
    },
    exportMemberUser: (payload) => {
        return {
            type: "USERS/EXPORT_MEMBER_USER",
            payload: payload
        }
    },
    changeUserStatus: (payload) => {
        return {
            type: "USERS/CHANGE_USER_STATUS",
            payload: payload
        }
    },
    changeAssignPayers: (payload) => {
        return {
            type: "USERS/CHANGE_ASSIGN_PAYERS",
            payload: payload
        }
    },
    getTemplate: (payload) => {
        return {
            type: "USERS/GET_TEMPLATE",
            payload: payload
        }
    },
    deleteMember: (payload) => {
        return {
            type: "USERS/DELETE_MEMBER",
            payload: payload
        }
    },
    uploadSheet: (payload) => {
        return {
            type: "USERS/UPLOAD_SHEET",
            payload: payload
        }
    },
    reRequest: (payload) => {
        return {
            type: "USERS/RE_REQUEST",
            payload: payload
        }
    },
    getMemberRoles: (payload) => {
        return {
            type: "USERS/GET_MEMBER_ROLES",
            payload: payload
        }
    },
    getRolesPermissions: (payload) => {
        return {
            type: "USERS/GET_ROLE_PERMISSION",
            payload: payload
        }
    },
    updateMemberUser: (payload) => {
        return {
            type: "USERS/UPDATE_MEMBER_USER",
            payload: payload
        }
    },
    createMemberUser: (payload) => {
        return {
            type: "USERS/CREATE_MEMBER_USER",
            payload: payload
        }
    },
    assignPayersToMemberUser: (payload) => {
        return {
            type: "USERS/ASSIGN_PAYER_TO_MEMBER_USER",
            payload: payload
        }
    },
    assignGroupID: (payload) => {
        return {
            type: "USERS/ASSIGN_GROUP_IDS",
            payload: payload
        }
    },
    checkCreateMemberAllowed: (payload) => {
        return {
            type: "USERS/CHECK_CREATE_MEMBER_ALLOWED",
            payload: payload
        }
    },
}

function* getMembersListAsync(action) {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.GRID_LOADING }));
        const { rowsPerPage, skip, IsDesc, filterText, selectedMember } = action.payload;
        
        const response = yield PayerDataService.getMemberList({
            PageNumber: (skip / rowsPerPage) + 1, PageSize: rowsPerPage, FilterText: filterText, IsDesc: IsDesc
        });

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            const totalMembers = response.data.Message.replace("Found ", "").replace(" Members", "")
            yield put(setMemberData([...response.data.Data]))
            yield put(setTotalMembers(parseInt(totalMembers)))
            if(selectedMember?.UserId){
                yield put(setSelectedMember(response.data.Data.find(user => user.UserId === selectedMember.UserId)))
            }
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GRID_READY }))
    }
}

function* exportToExcelMemberUserPayersAsync(action) {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.EXPORT_LOADING }));

        const response = yield RightsManagementDataService.exportToExcelMemberUserPayers();

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setExportFile(response.data.Data))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.EXPORT_READY }))
    }
}

function* exportMemberUserAsync() {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.EXPORT_LOADING }));

        const response = yield RightsManagementDataService.exportMemberUser();

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setExportFile(response.data.Data))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.EXPORT_READY }))
    }
}

function* changeUserStatusAsync(action) {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.STATUS_LOADING }));

        const response = yield RightsManagementDataService.changeUserStatus(action.payload);

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setShouldLoadMemberList(true))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.STATUS_READY }))
    }
}

function* getTemplateAsync(action) {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.IMPORT_LOADING }));

        const response = yield RightsManagementDataService.getTemplate();

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setExportFile(response.data.Data))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.IMPORT_READY }))
    }
}

function* changeAssignPayersAsync(action) {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.ASSIGN_PAYER_LOADING }));

        const response = yield RightsManagementDataService.changeAssignPayers(action.payload);

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setShouldLoadMemberList(true))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ASSIGN_PAYER_READY }))
    }
}

function* deleteMemberAsync(action) {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.ACTIONS_LOADING }));

        const response = yield RightsManagementDataService.deleteMember(action.payload);

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(setShouldLoadMemberList(true))
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ACTIONS_READY }))
    }
}

function* reRequestAsync(action) {
    try {

        yield put(setLoadingState({ state: USER_LOADING_STATES.ACTIONS_LOADING }));

        const response = yield RightsManagementDataService.reRequest(action.payload);

        if(response.data.Status === 0){
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else {
            yield put(addNotifications({
                heading: "Success",
                message: 'A new request has been sent to the member',
                variant: TOASTER_VARIANT.SUCCESS
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ACTIONS_READY }))
    }
}

function* uploadSheetAsync(action) {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.IMPORT_LOADING }))
        const uploadedFile = action.payload;

        const formData = new FormData();
        formData.append("files", uploadedFile);

        const response = yield RightsManagementDataService.uploadSheet(formData);
        if (response?.data.Status === 1) {
            const saveResponse = yield RightsManagementDataService.bulkSave();
            if(saveResponse.data.Status === 1) {
                yield put(addNotifications({ 
                    heading: "Success", 
                    message: saveResponse.data.Message,
                    variant: TOASTER_VARIANT.SUCCESS }));
                    yield put(setShouldLoadMemberList(true))
            }
            else {
                yield put(addNotifications({ heading: "Error Importing User", message: saveResponse?.data?.Message }));
            }
        } else {
            yield put(addNotifications({ heading: "Something went wrong, file not uploaded successfully", message: response?.data?.Message }));
        }

    } catch (error) {

        yield put(addNotifications({ heading: "Failed to upload a file", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.IMPORT_READY }))
        yield put(setUploadedFile(null))
        yield put(setShowImportPopup(false))
    }

}

function* getMemberRolesAsync() {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GENERAL_LOADING }))
        const response = yield RightsManagementDataService.getMemberRoles();
        if (response?.data.Status === 1) {
                yield put( setMemberRoles(response.data.Data.map(role => ({label: role.Value, value: role.Key}))) )
        } else {
            yield put(addNotifications({ 
                heading: "Error Fetching Member Roles", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles", 
            message: error?.response?.data?.Message 
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GENERAL_READY }))
    }

}

function* getRolesPermissionsAsync(action) {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GENERAL_LOADING }))
        const {role, selectedMember} = action.payload;
        const response = yield RightsManagementDataService.getRolesPermissions({memberId: 0, Role: role});
        if (response?.data.Status === 1) {
            if(selectedMember.hasOwnProperty('UserId')) {
                delete response.data.Data.Member.UserId
                delete response.data.Data.Member.AdminMasterId
                delete response.data.Data.Member.CheckTINMatch
            }
            delete response.data.Data.Member.FirstName
            delete response.data.Data.Member.Email
            delete response.data.Data.Member.PhoneNumber

            const userData = {...selectedMember, ...response.data.Data.Member }
                yield put(setSelectedMember(userData))
                yield put(setDisabledFields([...response.data.Data.DisabledFields]))
        } else {
            yield put(addNotifications({ 
                heading: "Error Fetching Member Roles", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles", 
            message: error?.response?.data?.Message 
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GENERAL_READY }))
    }

}


function* updateMemberUserAsync(action) {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GENERAL_LOADING }))
        const response = yield RightsManagementDataService.updateMemberUser(action.payload);
        if (response?.data.Status === 1) {
            yield put(setShouldLoadMemberList(true))
            yield put(setSelectedMember({}))
            yield put(setShowUserInfoPopup(false))
        } else {
            yield put(addNotifications({ 
                heading: "Error updating Member", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles", 
            message: error?.response?.data?.Message 
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GENERAL_READY }))
    }

}

function* createMemberUserAsync(action) {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GENERAL_LOADING }))
        const response = yield RightsManagementDataService.createMemberUser(action.payload);
        if (response?.data.Status === 1) {
            yield put(setShouldLoadMemberList(true))
            yield put(setShowUserInfoPopup(false))
            yield put(setSelectedMember({}))
        } else {
            yield put(addNotifications({ 
                heading: "Error updating Member", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles", 
            message: error?.response?.data?.Message 
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GENERAL_READY }))
    }

}

function* assignPayersToMemberUserAsync(action) {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ASSING_MEMBER_LOADING }))
        const response = yield PayerDataService.assignPayers(action.payload);
        if (response?.data.Status === 1) {
        yield put(setShouldLoadMemberList(true))
        yield put(setShowUserInfoPopup(false))
        } else {
            yield put(addNotifications({ 
                heading: "Error updating Member", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles", 
            message: error?.response?.data?.Message 
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ASSING_MEMBER_READY }))
    }

}

function* assignGroupIDAsync(action) {

    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ASSING_MEMBER_LOADING }))
        const response = yield RightsManagementDataService.assigningPayersWithGroupId(action.payload);
        if (response?.data.Status === 1) {
        yield put(setShouldLoadMemberList(true))
        yield put(setShowUserInfoPopup(false))
        } else {
            yield put(addNotifications({ 
                heading: "Error updating Member", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles", 
            message: error?.response?.data?.Message 
        }));
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.ASSING_MEMBER_READY }))
    }

}

function* checkCreateMemberAllowedAsync(){
    try {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GRID_LOADING }))
        const response = yield RightsManagementDataService.IsAllowMemberToCreate();
        if (response?.data.Status === 1) {
            yield put(setIsAllowMemberToCreate(response?.data?.Data ?? false))
        } else {
            yield put(setIsAllowMemberToCreate(false)) // Making it false as default value of this state is null. This will make the useEffect handle the condition on this endpoint completion.
            yield put(addNotifications({ 
                heading: "Facing some error", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {
        yield put(setIsAllowMemberToCreate(false)) // Making it false as default value of this state is null. This will make the useEffect handle the condition on this endpoint completion.
        console.log(error)
    } finally {
        yield put(setLoadingState({ state: USER_LOADING_STATES.GRID_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getMembersList().type, getMembersListAsync),
        takeLatest(exportToExcelMemberUserPayers().type, exportToExcelMemberUserPayersAsync),
        takeLatest(exportMemberUser().type, exportMemberUserAsync),
        takeLatest(changeUserStatus().type, changeUserStatusAsync),
        takeLatest(changeAssignPayers().type, changeAssignPayersAsync),
        takeLatest(deleteMember().type, deleteMemberAsync),
        takeLatest(getTemplate().type, getTemplateAsync),
        takeLatest(uploadSheet().type, uploadSheetAsync),
        takeLatest(reRequest().type, reRequestAsync),
        takeLatest(getMemberRoles().type, getMemberRolesAsync),
        takeLatest(getRolesPermissions().type, getRolesPermissionsAsync),
        takeLatest(updateMemberUser().type, updateMemberUserAsync),
        takeLatest(createMemberUser().type, createMemberUserAsync),
        takeLatest(assignPayersToMemberUser().type, assignPayersToMemberUserAsync),
        takeLatest(assignGroupID().type, assignGroupIDAsync),
        takeLatest(checkCreateMemberAllowed().type, checkCreateMemberAllowedAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);